import React from "react";

import useAuth from "../../routes/login/AuthContext";
import { TableCell } from "../../UI/TableCell";
import { TableHead } from "../../UI/TableHead";
import { TableRow } from "../../UI/TableRow";
import { HelpTooltip } from "../HelpTooltip";

const ENABLE_ACCESS_HELP_TITLE = "Enabled Access";
const ENABLE_ACCESS_HELP_CONTENT =
  "If this is enabled then residents will be imported and invited to RoomSync as soon as their lease is approved by the leasing office.";

const INSTANCE_ID_HELP_TITLE = "Instance ID";
const INSTANCE_ID_HELP_CONTENT =
  "The unique identifier for this integration instance in the Kinetic system.";

export const IntegrationTableKineticHead = () => {
  const { isSuperAdmin } = useAuth();

  return (
    <TableHead>
      <TableRow>
        <TableCell>RoomSync Floor Plan</TableCell>
        <TableCell>
          <HelpTooltip title={INSTANCE_ID_HELP_TITLE} text={INSTANCE_ID_HELP_CONTENT}>
            Instance ID
          </HelpTooltip>
        </TableCell>
        <TableCell>
          <HelpTooltip title={ENABLE_ACCESS_HELP_TITLE} text={ENABLE_ACCESS_HELP_CONTENT}>
            Enabled Access
          </HelpTooltip>
        </TableCell>
        <TableCell>Mapping Type</TableCell>
        <TableCell>Year of Study</TableCell>
        <TableCell>Import Fields</TableCell>
        <TableCell>Student Type</TableCell>
        <TableCell>Pathway ID</TableCell>
        {isSuperAdmin() && <TableCell />}
      </TableRow>
    </TableHead>
  );
};
